import useGetListDomicileQuery, { EDomicileType } from '../apis/queries/use-get-list-domicile-query'

export const useGetDomicileData = (values: string[]) => {
  const provinceQuery = useGetListDomicileQuery(
    {
      type: EDomicileType.PROVINCES || 'provinces',
    },
    true,
  )
  const cityQuery = useGetListDomicileQuery(
    {
      type: EDomicileType.CITIES || 'cities',
      province: values[0] || '',
    },
    !!values[0],
  )
  const districtQuery = useGetListDomicileQuery(
    {
      type: EDomicileType.DISTRICTS || 'districts',
      province: values[0] || '',
      city: values[1] || '',
    },
    !!values[1],
  )
  const subdistrictQuery = useGetListDomicileQuery(
    {
      type: EDomicileType.SUBDISTRICTS || 'subdistricts',
      province: values[0] || '',
      city: values[1] || '',
      district: values[2] || '',
    },
    !!values[2],
  )
  const zipCodeQuery = useGetListDomicileQuery(
    {
      type: EDomicileType.ZIP_CODE || 'zipCode',
      province: values[0] || '',
      city: values[1] || '',
      district: values[2] || '',
      subdistrict: values[3] || '',
    },
    !!values[3],
  )

  return {
    dataProvince: provinceQuery.data,
    isLoadingProvince: provinceQuery.isFetching,

    dataCity: cityQuery.data,
    isLoadingCity: cityQuery.isFetching,

    dataDistrict: districtQuery.data,
    isLoadingDistrict: districtQuery.isFetching,

    dataSubdistrict: subdistrictQuery.data,
    isLoadingSubdistrict: subdistrictQuery.isFetching,

    dataZipCode: zipCodeQuery.data,
    isLoadingZipCode: zipCodeQuery.isFetching,
  }
}
